import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../config/settings";
import httpRequest from "../../utils/httpRequest";

const initialState = {
    user: null,
    loading: false,
    error: null
};

export const getProfile = createAsyncThunk("profile/getProfile", async (userId) => {
    return httpRequest(`${BASE_URL}/users/view-profile?userid=${userId}`, "get");
});

export const updateProfile = createAsyncThunk(
    "profile/updateProfile", 
    async (profileData, { rejectWithValue }) => {
        try {
            const response = await httpRequest(
                `${BASE_URL}/users/update-profile`, 
                "post", 
                profileData
            );
            
            if (response?.status >= 400 || response?.error) {
                throw response;
            }
            
            return response;
        } catch (error) {
            return rejectWithValue(
                error?.response?.data?.ResponseDescription ||
                error?.response?.data?.responseDescription ||
                error?.message ||
                'Failed to update profile'
            );
        }
    }
);

const profileSlice = createSlice({
    name: "profile",
    initialState,
    reducers: {
        clearProfileError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getProfile.pending, (state) => {
                state.loading = true;
            })
            .addCase(getProfile.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.user = payload.data;
                state.error = null;
            })
            .addCase(getProfile.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
            })
            .addCase(updateProfile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateProfile.fulfilled, (state, { payload }) => {
                state.loading = false;
                if (payload?.data) {
                    state.user = { ...state.user, ...payload.data };
                }
                state.error = null;
            })
            .addCase(updateProfile.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
            });
    }
});

export default profileSlice.reducer;
export const { clearProfileError } = profileSlice.actions;